export const dnldCampaigns = (builder) => ({
    dnldCampaigns: builder.mutation({
        query: ({ loggedin_user_id, user_type_id, campaign_type, user_type, startDate, endDate, userId, status, search }) => {
            return {
                url: '/download_campaign_list',
                method: 'GET',
                params: { loggedin_user_id, user_type_id, campaign_type, user_type, startDate, endDate, userId, status, search },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});